import React, {useState, useEffect } from 'react';
//import dissabilities from '../data/dissabilities.json';
import benefits from '../data/benefits.json';

import { getKindergartensList } from '../../../kindergartens/list/actions';

import { formatAddress } from '../helpers/address';

import { getDisabilitiesList } from '../../../../services/apiClient'; 



const SELECTED_KG_PERM = 'cabinetkgselected';


const typeDocs = [
    { "name": "Довідка", "value": "1" },
    { "name": "Висновок", "value": "2" },
    { "name": "Направлення", "value": "3"}
];

const typePlaceMap = {
      'standart': 'Повного дня',
      'without-bed': 'Короткотривале',
      'inclusive': 'Інклюзивне',
      'inclusive-short': 'Інклюзивне короткотривале'
    };



const getPMInfo = ()=> {
    const sel_pm_info = localStorage.getItem(SELECTED_KG_PERM);
    return sel_pm_info && JSON.parse(sel_pm_info) || [];
}


const Step6 = ({ formData, errors, onChange, isPreview = false, isPrivelegedUser= false }) => {


  const [kg_info, setKGInfo] = useState(getPMInfo());

  const [dissabilities,  setDisabilitiesList] = useState([]);
  
  useEffect(()=>{
    setDisabilitiesList(getDisabilitiesList());
  }, [formData])

  useEffect(()=>{

    async function api(needInfoKgId, existInfoKg) {

      if(needInfoKgId.length < 1) return setKGInfo(existInfoKg);

      const result = await getKindergartensList({filters: { 'id_kg': needInfoKgId }});
      
      const resArr = [...existInfoKg, ...result]; ; 
      
      setKGInfo(resArr)
    };

    const neededKgDesc = formData.selectedSchools;

    const localInfoKgs = getPMInfo();

    const localIdArr = localInfoKgs.map(r=>r._id);

    const leftKgs = neededKgDesc.filter(n=>!localIdArr.includes(n));

    api(leftKgs, localInfoKgs);

  }, [formData.selectedSchools]);

  useEffect(()=>{if(errors.agreePersonalData) alert(errors.agreePersonalData)},[errors.agreePersonalData]);

  const getGenderName = (gender) => {
    return !gender ? ' - ' : ['girl'].includes(gender) ? 'Дівчинка' : 'Хлопчик';
  };

  const getCountryName = (country) => {
    return country === 'ua' ? 'Україна' : 'Іноземна держава';
  };

  const formatDate = (ISODate) => ISODate ? new Date(ISODate).toLocaleDateString('uk') : 'Не вказано';

  const getSelectedSchools = (kgl) => kg_info.filter(t => kgl.includes(t._id)).map(kg => ([kg.number, kg.name].join(" ")));

  
  const formatFiles = n => `${n} файл${n % 10 === 1 && n % 100 !== 11 ? '' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 'а' : 'ов'}`;

  // Функція для відображення інформації про документи
  const renderDocumentInfo = (document, prefix = '') => (
    <>
      <div className="review-row">
        <span className="review-label">{prefix}Тип документа:</span>
        <span className="review-value">{document.type || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Номер документа:</span>
        <span className="review-value">{document.number || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Кому видано:</span>
        <span className="review-value">{document.issuedTo || 'Не вказано'}</span>
      </div>
      <div className="review-row">
        <span className="review-label">{prefix}Дата видачі:</span>
        <span className="review-value">{document.issueDate ? formatDate(document.issueDate) : 'Не вказано'}</span>
      </div>
      {!isNaN(+document.docScan) && 
      <div className="review-row">
        <span className="review-label">{prefix}Скани документу:</span>
        <span className="review-value">{document.docScan ? formatFiles(document.docScan) : 'Не додані'}</span>
      </div>}
    </>
  );

  // Функція для отримання текстового опису мови навчання
  const getLanguageTrainingText = () => {
    const { languageTraining } = formData.preferences || {};

    if (languageTraining === 'ir') return 'Івріт (за міжнародним договором)';
    if (languageTraining === 'uk') return 'Українська мова';
    return 'Не вказано';
  };

  // Функція для отримання текстового опису типу місця
  const getPlaceTypeText = () => {
    const { withoutBed, notWithoutBed, notWithoutFullDay } = formData.preferences || {};
    
    if (withoutBed && notWithoutBed) {
      return '⚠️ Обрано суперечливі варіанти';
    }
    if (withoutBed) {
      return 'Надсилати з місцями короткотривале перебування (без спального місця)';
    }
    if (notWithoutFullDay) {
      return 'Не надсилати запрошення на місця повного дня';
    }
    if (notWithoutBed) {
      return 'Не надсилати до закладів з короткотривалим перебуванням';
    }
    return 'Не обрано (стандартні умови)';
  };

  // Додайте функцію перед return в Step6
  const shouldShowInvite = () => {
    const { invite, currentStatus } = formData;
    if (!invite) return false;
    
    // Перевіряємо за currentStatus
    if (currentStatus?.name === 'invite-sent' || currentStatus?.name === 'invite-accepted') {
      return true;
    }
    
    // Або перевіряємо за полями в invite
    if (invite.inviteStatus === 'sent' || invite.inviteStatus === 'accepted') {
      return true;
    }
    
    return false;
  };

  // Функція для відображення адреси з урахуванням позначки про відсутність в довіднику
  const renderAddress = (addressObj, addressText, isAddressKyiv, notFindInDictionary, label) => {
    if (isAddressKyiv === "yes") {
      if (notFindInDictionary === true) {
        return (
          <div className="review-row">
            <span className="review-label">{label}:</span>
            <span className="review-value">
              {addressText || 'Не вказано'}
              <span className="badge badge-warning ms-2" style={{ backgroundColor: '#ffc107', color: '#000', padding: '2px 8px', borderRadius: '4px', marginLeft: '8px', fontSize: '12px' }}>
                ⚠️ Адреса не знайдена в довіднику
              </span>
            </span>
          </div>
        );
      }
      return (
        <div className="review-row">
          <span className="review-label">{label}:</span>
          <span className="review-value">{formatAddress(addressObj, formData.dictionary.addresses)}</span>
        </div>
      );
    }
    return (
      <div className="review-row">
        <span className="review-label">{label}:</span>
        <span className="review-value">{addressText || 'Не вказано'}</span>
      </div>
    );
  };

  return (
    <div className="form-section form-section--wide">
      {!isPreview && <>
          <h2  className="form-section-title">Погодження з умовами</h2>

          {/* Соглашение */}
          <div className="mt-4">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="agreePersonalData"
                checked={formData.agreePersonalData == "yes"}
                onChange={(e) => onChange('agreePersonalData', formData.agreePersonalData == "yes" ? "no" : "yes")}
              />
              <label className="form-check-label" htmlFor="agreePersonalData">
                {isPrivelegedUser ? 'Підтверджую, що заявник надав право на обробку його персональних даних' : 'Погоджуюсь на оброблення персональних даних'}
              </label>
            </div>
            {errors.agreePersonalData && <div style={{ paddingLeft: '32px'}} className="invalid-feedback">{errors.agreePersonalData}</div>}
          </div>

          <div className="mt-3 alert alert-info">
            <strong>Увага!</strong> Будь ласка, уважно перевірте всі введені дані перед відправкою заявки.
          </div>

      </>}

      <div className="review-section">
        {/* Дані дитини */}
        <div className="review-block">
          <h3 className="review-title">Дані дитини</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">ПІБ дитини:</span>
              <span className="review-value">
                {formData.child.lastName} {formData.child.firstName} {formData.child.secondName}
              </span>
            </div>
            <div className="review-row">
              <span className="review-label">Дата народження:</span>
              <span className="review-value">{formatDate(formData.child.birthDate)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Стать:</span>
              <span className="review-value">{getGenderName(formData.child.gender)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Свідоцтво про народження:</span>
              <span className="review-value">{formData.child.birthCertificate.seriesNumber || 'Не вказано'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Дата видачі свідоцтва:</span>
              <span className="review-value">{formatDate(formData.child.birthCertificate.issueDate)}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Країна видачі:</span>
              <span className="review-value">{getCountryName(formData.child.birthCertificate.country)}</span>
            </div>
            
            {/* Зареєстрована адреса з урахуванням позначки */}
            {renderAddress(
              formData.child.addressYur, 
              formData.child.address, 
              formData.child.isAddressKyiv, 
              formData.child.notFindKyivAddress,
              'Зареєстрована адреса проживання'
            )}
            
            {/* Фактична адреса */}
            {formData.child.sameFactAddress === "yes" ? (
              <div className="review-row">
                <span className="review-label">Фактична адреса проживання:</span>
                <span className="review-value">Співпадає з зареєстрованою</span>
              </div>
            ) : (
              renderAddress(
                formData.child.addressFact, 
                formData.child.addressFactStr, 
                formData.child.isAddressKyiv, 
                formData.child.notFindKyivAddress,
                'Фактична адреса проживання'
              )
            )}
          </div>
        </div>

        {/* Інформація про запрошення - показуємо для статусів invite-sent та invite-accepted */}
        {shouldShowInvite() && (
          <div className="review-section">
            <div className="review-block">
            <h3 className="review-title">
              {formData.currentStatus?.name === 'invite-accepted' ? '✅ Прийняте запрошення' : '📨 Активне запрошення'}
            </h3>
            <div className="review-content">
              <div className="review-row">
                <span className="review-label">Статус:</span>
                <span className="review-value">
                  {formData.currentStatus?.name === 'invite-accepted' ? 'Прийнято' : 'Очікує відповіді'}
                </span>
              </div>
              <div className="review-row">
                <span className="review-label">Заклад дошкільної освіти:</span>
                <span className="review-value">
                  {getSelectedSchools([formData.invite.kindergartenId])}
                </span>
              </div>
              <div className="review-row">
                <span className="review-label">Номер групи:</span>
                <span className="review-value">{formData.invite.groupNumber || 'Не вказано'}</span>
              </div>
              <div className="review-row">
                <span className="review-label">Тип місця:</span>
                <span className="review-value">
                  { typePlaceMap[formData.invite.placeType] || ' - '}
                </span>
              </div>
              <div className="review-row">
                <span className="review-label">Дата запрошення:</span>
                <span className="review-value">{formatDate(formData.invite.inviteDate)}</span>
              </div>
              <div className="review-row">
                <span className="review-label">Дійсне до:</span>
                <span className="review-value">{formatDate(formData.invite.expiryDate)}</span>
              </div>
              
              {formData.currentStatus?.name === 'invite-sent' && (() => {
                const now = new Date();
                const expiryDate = new Date(formData.invite.expiryDate);
                const isExpired = expiryDate < now;
                const daysLeft = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
                
                return (
                  <>
                    {isExpired ? (
                      <div className="alert alert-danger mt-2">
                        <strong>⚠️ Термін дії запрошення минув!</strong> Будь ласка, зверніться до адміністратора.
                      </div>
                    ) : daysLeft <= 3 && (
                      <div className="alert alert-warning mt-2">
                        <strong>⏰ Увага!</strong> До закінчення терміну дії запрошення залишилося {daysLeft} днів.
                      </div>
                    )}
                  </>
                );
              })()}
              
              
            </div>
            </div>
          </div>
        )}

        {/* Дані заявника */}
        <div className="review-block">
          <h3 className="review-title">Дані заявника</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">ПІБ заявника:</span>
              <span className="review-value">
                {formData.applicant.lastName} {formData.applicant.firstName} {formData.applicant.middleName}
              </span>
            </div>
            <div className="review-row">
              <span className="review-label">Громадянство:</span>
              <span className="review-value">{formData.applicant.citizenship}</span>
            </div>
            <div className="review-row">
              <span className="review-label">РНОКПП:</span>
              <span className="review-value">
                {formData.applicant.hasRnokpp === 'no' ? 
                  'Відсутній (релігійні переконання)' : 
                  formData.applicant.rnokpp || 'Не вказано'}
              </span>
            </div>
            
            {/* Документ, що посвідчує особу (якщо немає РНОКПП) */}
            {formData.applicant.hasRnokpp === 'no' && (
              <>
                <div className="review-row">
                  <span className="review-label">Вид документу:</span>
                  <span className="review-value">
                    {formData.applicant.documentType === 'passport' ? 
                      'паспорт' : 
                      formData.applicant.documentType === 'idCard' ? 
                      'ID картка' : 'Не вказано'}
                  </span>
                </div>
                <div className="review-row">
                  <span className="review-label">Реквізити документу:</span>
                  <span className="review-value">{formData.applicant.documentDetails || 'Не вказано'}</span>
                </div>
              </>
            )}
            
            <div className="review-row">
              <span className="review-label">Телефон:</span>
              <span className="review-value">{formData.applicant.phone || 'Не вказано'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Email:</span>
              <span className="review-value">{formData.applicant.email || 'Не вказано'}</span>
            </div>
            
            {/* Адреса заявника з урахуванням позначки */}
            {renderAddress(
              formData.applicant.address, 
              formData.applicant.addressStr, 
              formData.applicant.isAddressKyiv, 
              formData.applicant.notFindKyivAddress,
              'Адреса проживання'
            )}
          </div>
        </div>

        {/* Додаткові побажання */}
        <div className="review-block">
          <h3 className="review-title">Додаткові побажання</h3>
          <div className="review-content">
            <div className="review-row">
              <span className="review-label">Бажана дата вступу:</span>
              <span className="review-value">{formatDate(formData.preferences.desiredDate)}</span>
            </div>

            <div className="review-row">
              <span className="review-label">Мова навчання:</span>
              <span className="review-value">{getLanguageTrainingText()}</span>
            </div>
            
            {/* Типи місць */}
            <div className="review-row">
              <span className="review-label">Тип місця:</span>
              <span className="review-value">{getPlaceTypeText()}</span>
            </div>
            
            <div className="review-row">
              <span className="review-label">Бажаю відвідувати групу меншу за віком:</span>
              <span className="review-value">{formData.preferences.ageMenu ? 'Так' : 'Ні'}</span>
            </div>
            <div className="review-row">
              <span className="review-label">Інклюзивна група:</span>
              <span className="review-value">{formData.preferences.inclusiveGroup ? 'Так' : 'Ні'}</span>
            </div>
            
            {formData.preferences.diseaseType && typeDocs.find(t=>t.value == formData.preferences.diseaseDocument?.type) && (
              <>
                <div className="review-row">
                  <span className="review-label">Вид захворювання:</span>
                  <span className="review-value">
                    {dissabilities?.find(s => s._id == formData.preferences?.diseaseType)?.label || 'Не вказано'}
                  </span>
                </div>
                {renderDocumentInfo(Object.assign({}, formData.preferences?.diseaseDocument, {type: typeDocs.find(t=>t.value == formData.preferences?.diseaseDocument.type)?.["name"] || formData.preferences?.diseaseDocument.type}))}
              </>
            )}
          </div>
        </div>

        {/* Пільги */}
        {formData.benefits.type && (
          <div className="review-block">
            <h3 className="review-title">Пільги</h3>
            <div className="review-content">
              <div className="review-row">
                <span className="review-label">Вид пільги:</span>
                <span className="review-value">
                  {benefits.find(b => b._id == formData.benefits.type)?.name || 'Не вказано'}
                </span>
              </div>

              {/* Звичайні пільги (з документами) */}
              {formData.benefits.documentType && (
                renderDocumentInfo({type: formData.benefits.documentType, number: formData.benefits.documentNumber, issuedTo: formData.benefits.issuedTo, issueDate: formData.benefits.issueDate, docScan: formData.benefits.docScan})
              )}

              {/* Територія обслуговування */}
              {formData.benefits.address && (
                <div className="review-row">
                  <span className="review-label">Адреса для пільги:</span>
                  <span className="review-value">{formatAddress(formData.benefits.address, formData.dictionary.addresses)}</span>
                </div>
              )}

              {/* Брати та сестри в одному ЗДО */}
              {formData.benefits.kindergarten && !formData.benefits.employeeName && (
                <>
                  <div className="review-row">
                    <span className="review-label">Заклад дошкільної освіти:</span>
                    <span className="review-value">
                      {formData.benefits.kindergarten === 'sadok1' ? 'ДНЗ №1 "Сонечко"' :
                       formData.benefits.kindergarten === 'sadok2' ? 'ДНЗ №2 "Зірочка"' :
                       formData.benefits.kindergarten === 'sadok3' ? 'ДНЗ №3 "Чебурашка"' :
                       formData.benefits.kindergarten === 'sadok4' ? 'ДНЗ №4 "Казка"' :
                       formData.benefits.kindergarten}
                    </span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Свідоцтво про народження дитини:</span>
                    <span className="review-value">{formData.benefits.siblingBirthCertificate || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Ім'я дитини:</span>
                    <span className="review-value">{formData.benefits.siblingName || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Дата народження дитини:</span>
                    <span className="review-value">
                      {formData.benefits.siblingBirthDate ? formatDate(formData.benefits.siblingBirthDate) : 'Не вказано'}
                    </span>
                  </div>
                </>
              )}

              {/* Діти працівників закладу */}
              {formData.benefits.employeeName && (
                <>
                  <div className="review-row">
                    <span className="review-label">Заклад дошкільної освіти:</span>
                    <span className="review-value">
                      {formData.benefits.kindergarten === 'sadok1' ? 'ДНЗ №1 "Сонечко"' :
                       formData.benefits.kindergarten === 'sadok2' ? 'ДНЗ №2 "Зірочка"' :
                       formData.benefits.kindergarten === 'sadok3' ? 'ДНЗ №3 "Чебурашка"' :
                       formData.benefits.kindergarten === 'sadok4' ? 'ДНЗ №4 "Казка"' :
                       formData.benefits.kindergarten}
                    </span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">Ім'я працівника:</span>
                    <span className="review-value">{formData.benefits.employeeName || 'Не вказано'}</span>
                  </div>
                  <div className="review-row">
                    <span className="review-label">РНОКПП працівника:</span>
                    <span className="review-value">{formData.benefits.employeeRnokpp || 'Не вказано'}</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Обрані садочки */}
        {formData.selectedSchools && formData.selectedSchools.length > 0 && (
          <div className="review-block">
            <h3 className="review-title">Обрані садочки</h3>
            <div className="review-content">
              {getSelectedSchools(formData.selectedSchools).map((school, index) => (
                <div key={index} className="review-row">
                  <span className="review-label">Садочок {index + 1}:</span>
                  <span className="review-value">{school}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Особа, що подала заявку*/}
        { formData.isDifferentPerson?.email && (
          <div className="review-block">
            <h3 className="review-title">Заявка подана іншим користувачем</h3>
            <div className="review-content">
                <div className="review-row">
                  <span className="review-label">email:</span>
                  <span className="review-value">{formData.isDifferentPerson?.email}</span>
                </div>
                <div className="review-row">
                  <span className="review-label">ПІБ:</span>
                  <span className="review-value">{formData.isDifferentPerson?.last_name} {formData.isDifferentPerson?.first_name}</span>
                </div>
            </div>
          </div>
        ) }
      </div>
    </div>
  );
};

export default Step6;